import Image from "next/image";
import Link from "next/link";

import { getRankingSelectDayLabelFromValue } from "pages/[tenant]/ranking/utils/selectDaysOptions";

import { GamificationModal } from "shared/components/molecules/Gamification/GamificationModal";
import { ArrowDownIcon } from "shared/components/molecules/Gamification/assets/icons/ArrowDownIcon";
import PodiumIcon from "shared/components/molecules/Gamification/assets/icons/PodiumIcon";
import { INotification } from "shared/components/organisms/AppNotification/@types";
import { ILosePodiumMetadata } from "shared/components/organisms/AppNotification/@types/losePodiumTypes";
import { LosePodiumIcon } from "shared/components/organisms/AppNotification/assets/icons/LosePodiumIcon";
import SadFaceImage from "shared/components/organisms/AppNotification/assets/images/SadFace.png";
import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";
import { formatTimeAgo } from "shared/components/organisms/AppNotification/utils/formatTimeAgo";

import { LosePodiumNotificationContainer, SeeRankingButton } from "./styles";

interface ILosePodiumNotificationProps {
  notification: INotification<ILosePodiumMetadata>;
}

export const LosePodiumNotification = ({
  notification,
}: ILosePodiumNotificationProps) => {
  return (
    <LosePodiumNotificationContainer>
      <Notification.Container wasReaded={!!notification?.read_at}>
        <Notification.IllustrationContainer>
          <LosePodiumIcon />
        </Notification.IllustrationContainer>
        <div>
          <Notification.Title.Container>
            <Notification.Title.Highlight>
              Você perdeu posição no ranking
            </Notification.Title.Highlight>
          </Notification.Title.Container>

          <Notification.Content.Text>
            Você pode recuperar a sua posição completando missões e pontuando
            com os gatilhos.
          </Notification.Content.Text>

          <SeeRankingButton>
            <Link href={`/ranking`} prefetch={false}>
              Ver ranking
            </Link>
          </SeeRankingButton>

          <Notification.Footer.Container>
            <Notification.Footer.Text>
              {formatTimeAgo(notification?.created_at)}
            </Notification.Footer.Text>

            <Notification.Footer.Dot />

            <Notification.Footer.Text>
              {getRankingSelectDayLabelFromValue(
                notification?.metadata?.ranking_type,
              )}
            </Notification.Footer.Text>
          </Notification.Footer.Container>
        </div>

        <div className="user-info">
          <PodiumIcon />
          <div className="position-tag">
            <ArrowDownIcon /> -
            {notification?.metadata?.current_position -
              notification?.metadata?.old_position}
          </div>

          <GamificationModal.UserPhoto
            fullName={notification?.metadata?.user?.username}
            photoSrc={notification?.metadata?.user?.photo_address}
          />
          <Image
            alt=""
            src={SadFaceImage.src}
            width={SadFaceImage.width}
            height={SadFaceImage.height}
            className="sad-face-1"
          />
          <Image
            alt=""
            src={SadFaceImage.src}
            width={20}
            height={19}
            className="sad-face-2"
          />
        </div>
      </Notification.Container>
    </LosePodiumNotificationContainer>
  );
};
